
export default function ValueProposition() {
  const values = [
    {
      icon: 'ri-time-line',
      number: '15+',
      title: 'Năm kinh nghiệm',
      description: 'Chuyên tour Mỹ'
    },
    {
      icon: 'ri-group-line',
      number: '15.000+',
      title: 'Khách hàng',
      description: 'Đã đi Mỹ cùng chúng tôi'
    },
    {
      icon: 'ri-map-pin-user-line',
      number: '100%',
      title: 'Nhóm ngũ giác Việt',
      description: 'Hỗ trợ tại Mỹ'
    },
    {
      icon: 'ri-customer-service-2-line',
      number: '24/7',
      title: 'Chăm sóc khách hàng',
      description: 'Hỗ trợ mọi lúc'
    },
    {
      icon: 'ri-car-line',
      number: 'Roadtrip',
      title: 'Trải nghiệm độc đáo',
      description: 'Văn hóa bản địa'
    },
    {
      icon: 'ri-shield-check-line',
      number: 'CHẤT LƯỢNG',
      title: 'Dịch vụ trọn gói',
      description: 'An toàn - Uy tín'
    }
  ];

  return (
    <section id="value-proposition" className="py-20 bg-gradient-to-b from-[#eff6ff] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Tại sao chọn <span className="text-[#2563eb]">Phượt Mỹ</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Với hơn 15 năm kinh nghiệm tổ chức tour Mỹ, chúng tôi tự hào mang đến những trải nghiệm tuyệt vời nhất cho khách hàng
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center group"
            >
              <div className="w-16 h-16 bg-[#dbeafe] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-[#2563eb] transition-colors duration-300">
                <i className={`${item.icon} text-3xl text-[#2563eb] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="text-3xl font-bold text-[#2563eb] mb-2">{item.number}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="#services"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            <i className="ri-arrow-right-line mr-2"></i>
            Xem lý do chọn chúng tôi
          </a>
        </div>
      </div>
    </section>
  );
}
